"use strict";
// Copyright © Veeam Software Group GmbH.
Object.defineProperty(exports, "__esModule", { value: true });
exports.oldTokens = void 0;
const base_1 = require("../../../design/themes/base");
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
exports.oldTokens = GlobalDesignToken_1.GlobalDesignToken.createTokens(base_1.baseTheme, 'old');
//# sourceMappingURL=OldTokens.js.map